import {observer} from "mobx-react-lite";
import React, {useEffect} from "react";
import Game from "../../Games/Game";
import {useLocation} from "react-router-dom";
import clubStore from "../../../storage/ClubStore";

const NewGame = () => {
    const location = useLocation()
    useEffect(() => {
        clubStore.tournament.resetGame()
    }, [location.pathname])
    return (
        <Game/>
    )
}
export default observer(NewGame)